module.exports = {"610117001":"鹿苑街道","610117002":"泾渭街道","610117003":"崇皇街道","610117004":"姬家街道","610117005":"耿镇街道","610117006":"张卜街道","610117007":"通远街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610117.json
// module id = 2921
// module chunks = 0